import store from '@/store';

const checkPermission = value => {
  const { isCompanyUser, companyPermissions } = store.getters;

  if (!isCompanyUser) {
    return true;
  }

  const permissions = companyPermissions || [];

  if (!permissions || permissions.length === 0) {
    return false;
  }

  if (typeof value === 'object' && !Array.isArray(value)) {
    const { codes, mode = 'some' } = value;

    if (!Array.isArray(codes)) {
      console.error(
        '[v-permission] codes must be an array when using object format'
      );
      return false;
    }

    if (mode === 'every') {
      return codes.every(code => permissions.includes(code));
    }
    return codes.some(code => permissions.includes(code));
  }

  if (typeof value === 'string') {
    return permissions.includes(value);
  }

  if (Array.isArray(value)) {
    return value.some(code => permissions.includes(code));
  }

  console.error('[v-permission] invalid permission value:', value);
  return false;
};

export default {
  mounted(el, binding) {
    el._permissionCheck = () => {
      const hasPermission = checkPermission(binding.value);
      el.style.display = hasPermission ? '' : 'none';
    };

    el._permissionCheck();

    el._unwatchPermissions = store.watch(
      (state, getters) => getters.companyPermissions,
      () => {
        el._permissionCheck();
      }
    );
  },

  updated(el, binding) {
    if (binding.value === binding.oldValue) {
      return;
    }
    if (el._permissionCheck) {
      el._permissionCheck();
    }
  },

  unmounted(el) {
    if (el._unwatchPermissions) {
      el._unwatchPermissions();
    }
  }
};

export const permissionShow = {
  mounted(el, binding) {
    el._permissionShowCheck = () => {
      const hasPermission = checkPermission(binding.value);
      el.style.display = hasPermission ? '' : 'none';
    };

    el._permissionShowCheck();

    el._unwatchPermissionsShow = store.watch(
      (state, getters) => getters.companyPermissions,
      () => {
        el._permissionShowCheck();
      }
    );
  },

  updated(el, binding) {
    if (binding.value === binding.oldValue) {
      return;
    }
    if (el._permissionShowCheck) {
      el._permissionShowCheck();
    }
  },

  unmounted(el) {
    if (el._unwatchPermissionsShow) {
      el._unwatchPermissionsShow();
    }
  }
};

export const permissionDisabled = {
  mounted(el, binding) {
    el._permissionDisabledCheck = () => {
      const hasPermission = checkPermission(binding.value);

      if (hasPermission) {
        el.removeAttribute('disabled');
        el.classList.remove('is-disabled');
        el.style.cursor = '';
        el.style.opacity = '';
      } else {
        el.setAttribute('disabled', 'disabled');
        el.classList.add('is-disabled');
        el.style.cursor = 'not-allowed';
        el.style.opacity = '0.6';
      }
    };

    el._permissionDisabledCheck();

    el._unwatchPermissionsDisabled = store.watch(
      (state, getters) => getters.companyPermissions,
      () => {
        el._permissionDisabledCheck();
      }
    );
  },

  updated(el, binding) {
    if (binding.value === binding.oldValue) {
      return;
    }
    if (el._permissionDisabledCheck) {
      el._permissionDisabledCheck();
    }
  },

  unmounted(el) {
    if (el._unwatchPermissionsDisabled) {
      el._unwatchPermissionsDisabled();
    }
  }
};
